import React from 'react';
import { AppRoutes } from 'consts/routesPath';
import { Redirect } from 'react-router';
import getAuth from 'redux/selector/getAuth';

const Security = (props) => {
  const { isLogin } = getAuth();

  if (!isLogin) {
    return <Redirect to={AppRoutes.Login} />;
  }

  return props.children;
};

export default Security;
